import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Preloader } from './components/Preloader';
import { Navbar } from './components/Navbar';
import { Landing } from './pages/Landing';
import { Features } from './pages/Features';
import { Docs } from './pages/Docs';
import { Research } from './pages/Research';
import { OpenSource } from './pages/OpenSource';
import { AppHome } from './pages/AppHome';
import { TxDebug } from './pages/TxDebug';
import { StorageInspector } from './pages/StorageInspector';
import { Compare } from './pages/Compare';
import { ForkMode } from './pages/ForkMode';
import { Settings } from './pages/Settings';
import { UserDashboard } from './pages/UserDashboard';

export default function App() {
  return (
    <>
      <Preloader />
      <div className="min-h-screen bg-[#0A0A0A] text-[#E4E3E0] font-sans selection:bg-emerald-500/30">
        <Navbar />
        <Routes>
          {/* Public Marketing Pages */}
          <Route path="/" element={<Landing />} />
          <Route path="/features" element={<Features />} />
          <Route path="/docs/*" element={<Docs />} />
          <Route path="/research" element={<Research />} />
          <Route path="/open-source" element={<OpenSource />} />

          {/* Core Application Pages */}
          <Route path="/app" element={<AppHome />} />
          <Route path="/app/tx/:network/:txHash" element={<TxDebug />} />
          <Route path="/app/tx/:txHash" element={<TxDebug />} />
          <Route path="/app/storage/:address" element={<StorageInspector />} />
          <Route path="/app/compare" element={<Compare />} />
          <Route path="/app/fork" element={<ForkMode />} />
          <Route path="/app/settings" element={<Settings />} />
          <Route path="/app/dashboard" element={<UserDashboard />} />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </>
  );
}
